import { tns } from "./../../node_modules/tiny-slider/src/tiny-slider"
import noUiSlider from 'nouislider'
import wNumb from './Plugins/wNumb.js'
import Cookies from 'js-cookie'
import Tooltip from "@ryangjchandler/alpine-tooltip";

document.addEventListener('alpine:init', () => {
    // JS Cookie global
    window.cookie = Cookies;

    // Tiny slider global
    window.tns = tns

    //wNumb global
    window.wNumb = wNumb;

    // No Ui Slider global
    window.rangeSlider = noUiSlider

    Alpine.plugin(Tooltip);

    Alpine.store('loanInfo', {
        setCalculatedValues(value) {
            this.totalkreditcost = value.totalkreditcost;
            this.kreditcost = value.kreditcost;
            this.debitrente = value.debitrente;
            this.aop = value.aop
            this.monthlyPay = value.monthlyPay;
        },
        setCustomerSettings(a, m) {
            const language = document.documentElement.lang.toLowerCase().split('-')[0];
            const amountThousandsSeparator = ['no', 'nb', 'nn', 'sv'].includes(language) ? ' ' : '.';
            let moneyFormat = wNumb({
                decimals: 0,
                thousand: amountThousandsSeparator,
                suffix: ' kr.'
            });

            let monthFormat = wNumb({
                decimals: 0,
                suffix: ' mdr.'
            })

            this.amount = moneyFormat.to(a);
            this.months = monthFormat.to(m);
        },
        amount: '',
        months: '',
        totalkreditcost: '0',
        kreditcost: 0,
        monthlyPay: '0',
        debitrente: '',
        aop: '',
    })
})



// aspnet-client-validation bootup
import { ValidationService } from 'aspnet-client-validation';

// aspnet-client-validation bootup
import AspnetClientValidation from "./Plugins/validation.js";
AspnetClientValidation();



